import React from 'react';
import './modal.css';

interface ModalProps {
    children: React.ReactNode;
    open: boolean;
    onClose?: () => void;
}

export const Modal: React.FC<ModalProps> = ({ children, open, onClose = () => {} }) => {
    return (
        <div
            className={`modal modal-backdrop ${open ? 'modal-show' : ''}`}
            onClick={onClose}
        >
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
                className="modal-close"
                onClick={onClose}
            >
                &times;
            </a>
            <div
                className="modal-body"
                onClick={(evt) => evt.stopPropagation()}
                style={{ maxWidth: '800px' }}
            >
                {children}
            </div>
        </div>
    );
};
